export const insurancePlansByState = {
  Arizona: [
    "Aetna",
    "Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Healthcare",
    "Mercy Care",
    "UnitedHealthcare/Optum Behavioral Health",
    "Self-pay",
  ],
  California: [
    "Aetna",
    "Anthem Blue Cross",
    "Blue Shield of California",
    "Cigna/Evernorth Behavioral Healthcare",
    "Easterseals",
    "HealthNet",
    "San Francisco Health Plan (Carelon Behavioral Health)",
    "UnitedHealthcare/Optum Behavioral Health",
    "Self-pay",
  ],
  Connecticut: [
    "Aetna",
    "Anthem Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Healthcare",
    "ConnectiCare",
    "Humana",
    "UnitedHealthcare/Optum Behavioral Health",
    "Self-pay",
  ],
  Illinois: [
    "Aetna",
    "Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Healthcare",
    "Imagine Health",
    "UnitedHealthcare/Optum Behavioral Health",
    "Self-pay",
  ],
  "Massachusetts - Burlington, Braintree, and Danvers": [
    "Aetna",
    "Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Healthcare",
    "Harvard Pilgrim Health Plan",
    "Tufts Health Plan",
    "Tufts Health Public Plans",
    "United Healthcare/Optum Behavioral Health",
    "Wellpoint (formerly UniCare)",
    "Self-pay",
  ],
  "Massachusetts - Dedham, Shrewsbury, and West Springfield": [
    "Aetna",
    "BeHealthy Partnership (Behavioral Health Services Only)",
    "Blue Cross Blue Shield",
    "WellSense (BMC Health Plan)",
    "Cigna/Evernorth Behavioral Healthcare",
    "Fallon Health - all products except Atrius",
    "Harvard Pilgrim Health Plan",
    "Mass General Brigham Health Plan, Commercial only",
    "MassHealth (Medicaid)",
    "Tufts Health Plan",
    "Tufts Health Public Plans",
    "United Healthcare/Optum Behavioral Health",
    "Wellpoint (formerly UniCare)",
    "Self-pay",
  ],
  "New Jersey": [
    "Aetna",
    "AmeriHealth",
    "Cigna/Evernorth Behavioral Healthcare",
    "Horizon Blue Cross Blue Shield",
    "Optum Behavioral Health (Behavioral Health Services Only)",
    "Self-pay",
  ],
  "North Carolina": [
    "Aetna",
    "Alliance Health",
    "Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Healthcare",
    "Optum Behavioral Health (Behavioral Health Services Only)",
    "Self-pay",
  ],
  Texas: [
    "Aetna",
    "Blue Cross Blue Shield",
    "Cigna/Evernorth Behavioral Health",
    "First Health",
    "Humana POS/PPO",
    "Imagine Health",
    "Scott & White Health Plan (Behavioral Health Services Only)",
    "Superior/Ambetter",
    "UnitedHealthcare/Optum Behavioral Health",
    "Self-pay",
  ],
}
